import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Plan } from '../../interfaces/cached-content';
import { CacheService } from '../../ssr-services/cache/cache.service';

export const planHandlerGuard: CanActivateFn = (route) => {
  const planSlug = route.params['plan_slug'];
  const cacheService = inject(CacheService);
  const cacheContent = cacheService.cachedContent();
  const router = inject(Router);

  if (!cacheContent || !planSlug) {
    return true; // Let the route continue, will show 404
  }

  // Get the destination from parent route data
  const parentRoute = route.parent;
  if (!parentRoute?.data?.['destination']) {
    return router.navigate(['/404'], {
      skipLocationChange: true,
      replaceUrl: true,
    });
  }

  const destination = parentRoute.data['destination'];

  // Find the plan by slug within the destination's plans
  const foundPlan = destination.plans.find((plan: Plan) => plan.slug === planSlug);

  if (foundPlan) {
    // Store plan data in route data for the component to access
    route.data = {
      ...route.data,
      selectedPlan: foundPlan,
    };
    return true; // Allow navigation to continue
  }

  // Plan not found, show 404
  return router.navigate(['/404'], {
    skipLocationChange: true,
    replaceUrl: true,
  });
};
